import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterLienContextMenuProps {
  canDelete: boolean;
  id: string;
  isDeleting: boolean;
  label?: string | null;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  originalAmount?: number | null;
  trigger: ReactNode;
}

export const MatterLienContextMenu = ({
  canDelete,
  id,
  isDeleting,
  label,
  matter,
  onDelete,
  onEdit,
  originalAmount,
  trigger,
}: MatterLienContextMenuProps) => {
  const entityLabel = label || "lien";

  return (
    <MatterSubItemContextMenu
      createSignatureRequest
      copyValue={[
        entityLabel,
        originalAmount != null
          ? `Original amount: $${originalAmount}`
          : undefined,
      ]
        .filter(Boolean)
        .join("\n")}
      delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
      entityLabel={entityLabel}
      entityName="lien"
      matter={matter}
      onEdit={onEdit}
      subItem={{ id, type: "lien" }}
      trigger={trigger}
    />
  );
};
